import React, { forwardRef, type Ref } from 'react';
import { IconButton } from '@atlaskit/button/new';
import AddIcon from '@atlaskit/icon/utility/add';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { CellHoverProvider } from '@atlassian/jira-hover-popover/src/controllers/index.tsx';
import { HoverPopover, CellHoverRenderer } from '@atlassian/jira-hover-popover/src/ui/index.tsx';
import mergeRefs from '@atlassian/jira-merge-refs/src/index.tsx';
import messages from './messages.tsx';

type Props = {
	onClick?: () => void;
	isSingleLineRowHeightEnabled?: boolean;
	isCreateWorkItem?: boolean;
};

const getWorkItemMessage = () =>
	fg('jira-issue-terminology-refresh-m3') ? messages.createWorkItem : messages.createIssue;

const CreateChildButton = forwardRef(
	(
		{ onClick, isCreateWorkItem, isSingleLineRowHeightEnabled }: Props,
		ref: Ref<HTMLButtonElement>,
	) => {
		const { formatMessage } = useIntl();
		if (isSingleLineRowHeightEnabled) {
			return (
				<CellHoverProvider>
					<CellHoverRenderer>
						<HoverPopover
							content={
								isCreateWorkItem
									? formatMessage(getWorkItemMessage())
									: formatMessage(messages.createChildItem)
							}
						>
							{(props) => (
								<IconButton
									spacing="compact"
									appearance="subtle"
									label={
										isCreateWorkItem
											? formatMessage(getWorkItemMessage())
											: formatMessage(messages.createChildItem)
									}
									testId="issue-table-hierarchy.ui.create-child-button.create"
									icon={AddIcon}
									onClick={onClick}
									isTooltipDisabled
									ref={mergeRefs(ref, props.ref)}
								/>
							)}
						</HoverPopover>
					</CellHoverRenderer>
				</CellHoverProvider>
			);
		}

		return (
			<IconButton
				spacing="compact"
				appearance="subtle"
				label={
					isCreateWorkItem
						? formatMessage(getWorkItemMessage())
						: formatMessage(messages.createChildItem)
				}
				testId="issue-table-hierarchy.ui.create-child-button.create"
				icon={AddIcon}
				onClick={onClick}
				isTooltipDisabled={false}
				ref={ref}
			/>
		);
	},
);

export default CreateChildButton;
